import { FieldValue } from '@ahmdigital/form-validation/lib/validators/types';
import { isString } from 'lodash/fp';

export function validateName(value: FieldValue | undefined, title: string): string | null {
  // This regex allows letters (including accented letters), spaces, periods, apostrophes, and hyphens. It does not allow numbers or other symbols.
  const allowedNameCharactersRegex = /^[\p{L} .'-]+$/u;
  return isString(value) && value.length > 0 && !allowedNameCharactersRegex.test(value)
    ? `${title} cannot contain numbers or symbols`
    : null;
}
